import { TiArrowLeft } from "react-icons/ti";
import { LoginModal } from "../Login";
import { useState } from "react";

const InfoSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className="w-full h-[624px] bg-white/5 relative"
        style={{ background: "linear-gradient(to left, #57C5F9, #A36AFF)" }}
      >
        <div className="h-full bg-[url('/images/hero_bg.png')] bg-cover bg-center">
          <div className="container h-full p-5 mx-auto flex flex-col items-center justify-center">
            <div className="flex flex-col items-center text-center justify-center">
              <p className="font-kalameh text-white text-[18px] md:text-[48px]">
                شناخت مسیر کامل
              </p>
              <p className="font-kalameh text-white text-[18px] md:text-[48px]">
از صدای معمولی به خواندن حرفه ای
              </p>
            </div>
            <div className="flex items-center gap-3 justify-center">
              <p className="font-kalameh text-white text-[48px]">در</p>
              <p className="font-digital text-white text-[48px] mt-3">2:00</p>
              <p className="font-kalameh text-white text-[48px]">ساعت</p>
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="font-kalameh text-white bg-black/45 rounded-[38px] p-2.5 flex items-center justify-center gap-5 mt-20 hover:cursor-pointer"
            >
              ثبت نام رایگان و شروع
              <TiArrowLeft className="text-2xl" />
            </button>
            <img
              src="/images/isolation_mode2.png"
              alt="isolation"
              width={367}
              height={83}
              className="absolute bottom-0"
            />
          </div>
        </div>
      </div>
      {isModalOpen && <LoginModal onClose={() => setIsModalOpen(false)} />}

    </>
  );
};

export default InfoSection;
